import React from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { MessageType } from '../common/Constants';
import HelpActions from '../redux/actions/helpActions';
import HelpForm from '../components/forms/HelpForm';
import LoaderOverlay from '../components/LoaderOverlay';
import Message from '../components/Message';
import { translateArray } from '../common/Util';
import { getHelpErrorMessage } from '../common/MessageUtil';

export const Help = (props) => {
  const {
    t, success, error, isFetching, postHelpForm, requestId,
  } = props;

  const onSubmit = (formData) => {
    postHelpForm(formData);
  };

  const successMessage = 'Thank_you_for_submitting_a_request_to_our_Tableau_Customer_Service_team_we_will_reply_shortly._Our_normal_business_hours_are_5:30am_-_7:00pm_PST_Monday_-_Friday_and_we_typically_respond_within_the_same_business_day._If_you_have_any_additional_questions_or_concerns_please_reach_out_to_us_at_a_href_mailto:customerservice_tableausoftware.com_customerservice_tableausoftware.com_a_.';
  return (
    <section className="section">
      <div className="content-container" id="loading-overlay-content">
        {isFetching && <LoaderOverlay />}
        {error && (
          <Message
            id="errorMessage"
            text={translateArray(getHelpErrorMessage(error))}
            messageType={MessageType.error}
          />
        )}
        {success && <Message id="successMessage" text={t(successMessage)} messageType={MessageType.notice} />}
        {!success && <HelpForm onSubmit={onSubmit} isFetching={isFetching} />}
      </div>
      <input type="hidden" id="requestId" value={requestId} />
    </section>
  );
};

Help.propTypes = {
  t: PropTypes.func.isRequired,
  error: PropTypes.object,
  success: PropTypes.bool,
  isFetching: PropTypes.bool,
  postHelpForm: PropTypes.func.isRequired,
  requestId: PropTypes.string,
};

Help.defaultProps = {
  error: null,
  success: false,
  isFetching: false,
  requestId: '',
};

export const mapStateToProps = state => ({
  error: state.helpReducer.error,
  success: state.helpReducer.success,
  isFetching: state.helpReducer.isFetching,
  requestId: state.helpReducer.requestId,
});

const mapDispatchToProps = dispatch => ({
  postHelpForm: bindActionCreators(HelpActions, dispatch),
});

export default translate()(connect(mapStateToProps, mapDispatchToProps)(Help));
